import React, { FC } from 'react';
import { Button } from 'src/screens/OnboardingTrainer/components/Button/Button';

interface EmptyStateProps {
  message?: string;
  marginTop?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  hideIcon?: boolean;
  hideMessage?: boolean;
}

export const EmptyState: FC<EmptyStateProps> = ({
  message = 'No Data Found',
  marginTop = '40px',
  buttonText,
  onButtonClick,
  hideIcon = false,
  hideMessage = false,
}) => {
  if (buttonText && onButtonClick && hideIcon && hideMessage) {
    return (
      <div
        className="dashboard-empty-state"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '300px',
          width: '100%',
          marginTop: 0,
        }}
      >
        <Button variant="light" onClick={onButtonClick}>
          {buttonText}
        </Button>
      </div>
    );
  }

  return (
    <div
      className="dashboard-empty-state"
      style={{
        marginTop,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      {!hideIcon && (
        <svg
          width="65"
          height="64"
          viewBox="0 0 65 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32.5 32C37.6547 32 41.8333 27.8213 41.8333 22.6667C41.8333 17.512 37.6547 13.3333 32.5 13.3333C27.3453 13.3333 23.1667 17.512 23.1667 22.6667C23.1667 27.8213 27.3453 32 32.5 32ZM25.0333 34.6667C18.1093 34.6667 12.5 40.276 12.5 47.2V50.6667H52.5V47.2C52.5 40.276 46.8907 34.6667 39.9667 34.6667H25.0333Z"
            fill="#FFFFFF"
            fillOpacity="0.5"
          />
        </svg>
      )}
      {!hideMessage && <span style={{ marginBottom: buttonText ? '16px' : '0' }}>{message}</span>}
      {buttonText && onButtonClick && (
        <Button variant="light" onClick={onButtonClick} style={{ marginTop: 8 }}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};
